/** Font stack for standalone print HTML (matches app globals). */
export const PRINT_DOCUMENT_FONT_FAMILY = [
  '"Noto Sans Lao"',
  "ui-sans-serif",
  "system-ui",
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
].join(", ");

export function buildNotoSansLaoPrintFontFaceCss(fontDataUrl: string): string {
  if (!fontDataUrl) return "";
  return `
@font-face {
  font-family: "Noto Sans Lao";
  src: url("${fontDataUrl}") format("woff2");
  font-weight: 100 900;
  font-style: normal;
  font-display: block;
}
`;
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

/** Browser: embed Noto Sans Lao into print-window HTML as a data-URL @font-face. */
export async function loadNotoSansLaoPrintFontFaceCss(): Promise<string> {
  try {
    const { default: notoSansLaoVariable } = await import(
      "@/assets/Noto_Sans_Lao/NotoSansLao-VariableFont_wdth,wght.woff2"
    );
    const res = await fetch(notoSansLaoVariable);
    if (!res.ok) return "";
    const dataUrl = `data:font/woff2;base64,${arrayBufferToBase64(await res.arrayBuffer())}`;
    return buildNotoSansLaoPrintFontFaceCss(dataUrl);
  } catch {
    return "";
  }
}
